import { useState } from "react";

// Before/After comparison slider
export function ImageCompare({ before, after, alt = "Before and after" }) {
  const [pos, setPos] = useState(50);
  return (
    <div className="relative w-full aspect-[4/3] overflow-hidden rounded-2xl select-none group" data-testid="image-compare">
      <img src={after} alt={`${alt} — after`} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
      <img
        src={before}
        alt={`${alt} — before`}
        className="absolute inset-0 w-full h-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
        loading="lazy"
      />
      {/* labels */}
      <span className="absolute top-3 left-3 rounded-full bg-navy/80 text-white text-[11px] font-semibold px-2.5 py-1">Before</span>
      <span className="absolute top-3 right-3 rounded-full bg-brandgreen text-white text-[11px] font-semibold px-2.5 py-1">After</span>
      {/* divider */}
      <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow" style={{ left: `${pos}%` }}>
        <span className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 grid place-items-center w-9 h-9 rounded-full bg-white shadow-md text-navy">
          <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M8 7l-5 5 5 5V7zm8 0v10l5-5-5-5z" /></svg>
        </span>
      </div>
      <input
        type="range" min="0" max="100" value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Drag to compare before and after"
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
      />
    </div>
  );
}
